/* Delegated interactions survive Shopify section rendering and theme-editor reloads. */
(() => {
  if(window.ylRefinedReady)return; window.ylRefinedReady=true;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let active=null,generation=0,touch=null;
  const mediaOf=c=>c?.querySelector('.yl-product-preview'),videoOf=c=>c?.querySelector('[data-yl-product-preview]');
  function stop(){generation++;if(!active)return;mediaOf(active)?.classList.remove('is-previewing');videoOf(active)?.pause();delete active.dataset.ylTouchActive;active=null;}
  async function start(card){
    const video=videoOf(card);if(!video||reduce.matches||navigator.connection?.saveData)return false;
    if(active===card)return true;stop();active=card;const version=generation;
    video.muted=true;video.playsInline=true;video.loop=true;
    try{await video.play();if(generation===version&&active===card&&!video.paused)mediaOf(card)?.classList.add('is-previewing');}
    catch(_){if(generation===version)stop();return false;}return true;
  }
  document.addEventListener('pointerover',e=>{if(e.pointerType!=='mouse')return;const c=e.target.closest?.('.product-card-wrapper');if(c&&!c.contains(e.relatedTarget))start(c);});
  document.addEventListener('pointerout',e=>{if(e.pointerType==='mouse'&&active&&active.contains(e.target)&&!active.contains(e.relatedTarget))stop();});
  document.addEventListener('pointerdown',e=>{
    if(e.pointerType!=='touch')return;const card=e.target.closest?.('.product-card-wrapper'),box=mediaOf(card)?.getBoundingClientRect();
    const inside=box&&e.clientX>=box.left&&e.clientX<=box.right&&e.clientY>=box.top&&e.clientY<=box.bottom;
    touch=inside&&videoOf(card)?{card,x:e.clientX,y:e.clientY}:null;if(!touch)stop();
  },{passive:true});
  document.addEventListener('pointerup',e=>{if(e.pointerType==='touch'&&touch&&Math.hypot(e.clientX-touch.x,e.clientY-touch.y)>12)touch=null;},{passive:true});
  document.addEventListener('pointercancel',()=>{touch=null;},{passive:true});
  document.addEventListener('click',e=>{
    if(!touch)return;const {card}=touch;touch=null;
    if(!card.contains(e.target)||reduce.matches||navigator.connection?.saveData)return;
    if(card.dataset.ylTouchActive==='true'&&active===card){
      const link=card.querySelector('a[href*="/products/"]');
      if(link){e.preventDefault();e.stopPropagation();location.assign(link.href);}return;
    }
    e.preventDefault();e.stopPropagation();card.dataset.ylTouchActive='true';
    start(card).then(played=>{if(!played){const link=card.querySelector('a[href*="/products/"]');if(link)location.assign(link.href);}});
  },true);
  document.addEventListener('focusin',e=>{if(!e.target.matches?.(':focus-visible'))return;const c=e.target.closest?.('.product-card-wrapper');if(c)start(c);});
  document.addEventListener('focusout',e=>{if(active&&!active.contains(e.relatedTarget))stop();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
  window.addEventListener('pagehide',stop);
  window.addEventListener('pageshow',e=>{if(e.persisted){touch=null;stop();}});
  document.addEventListener('yunlore:catalogue:updated',stop);
  document.addEventListener('scroll',()=>{if(!active)return;const r=active.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)stop();},{passive:true});
  reduce.addEventListener('change',()=>{if(reduce.matches)stop();});
  document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;stop();document.querySelectorAll('.yl-mobile-menu[open]').forEach(m=>{m.open=false;m.querySelector('summary')?.focus();});});
  document.addEventListener('click',e=>{
    const plan=e.target.closest('[data-plan-route]');
    if(plan){const select=document.querySelector('select[name="contact[Route]"]');if(select){select.value=plan.dataset.planRoute;select.dispatchEvent(new Event('change',{bubbles:true}));}}
    const link=e.target.closest('.yl-mobile-menu__panel a');if(link)link.closest('details').open=false;
  });
})();
